import { RewardService } from '@/services';

export default {
	namespaced: true,
	state: {

	},
	mutations: {
		
	},
	actions: {
		async HasActiveCustomerProgram({ commit }, chainId) {
			var hasCustomerProgram = await RewardService.HasActiveCustomerProgram(chainId);
			return hasCustomerProgram;
		},
	}
};
